import { combineReducers } from "redux"

import violations from './violations'
import violationDetail from './violationDetail'
import violationsPagination from './violationsPagination'
export default combineReducers({
    violations,
    violationDetail, 
    violationsPagination,
});


// WEBPACK FOOTER //
// ./src/reducers/violationHistory/index.ts